import { render } from "./ConfigurationBankAccounts.vue?vue&type=template&id=0039977e&scoped=true"
import script from "./ConfigurationBankAccounts.vue?vue&type=script&lang=js"
export * from "./ConfigurationBankAccounts.vue?vue&type=script&lang=js"

import "./ConfigurationBankAccounts.vue?vue&type=style&index=0&id=0039977e&scoped=true&lang=scss"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0039977e"]])

export default __exports__